import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Home.css';
import logo from '../../assets/logo.png';

const HomeHero = () => {
  const { t } = useTranslation();
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasAnimated(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="hero-section">
      <div className={`hero-video-container ${hasAnimated ? 'animated' : ''}`}>
        <video 
          className="hero-video" 
          autoPlay 
          loop 
          muted 
          playsInline
        >
          <source src={require('../../assets/startVid.mp4')} type="video/mp4" />
          {t('home.videoNotSupported')}
        </video>
        <div className="video-overlay"></div>
      </div>
      
      {/* Protix Logo Overlay */}
      <div className={`hero-logo-overlay ${hasAnimated ? 'animated' : ''}`}>
        {/* <img src={logo} alt={t('home.protixLogo')} className="hero-logo" /> */}
      </div>

      <div className="hero-content">
        {/* Your content here */}
      </div>
    </div>
  );
};

export default HomeHero;
